import React, { useEffect, useState } from "react";
import PrivacyConsentFields from "./PrivacyConsentFields";
import { btn3d } from "../styles/buttonStyles";

export default function ConsentGate({
  dm,
  consentGate,
  privacyAgreed,
  overseasTransferAgreed,
  confirmConsentGate,
  closeConsentGate,
}) {
  const [privacyExpanded, setPrivacyExpanded] = useState(true);
  const [overseasTransferExpanded, setOverseasTransferExpanded] = useState(true);
  const [draftPrivacyAgreed, setDraftPrivacyAgreed] = useState(false);
  const [draftOverseasTransferAgreed, setDraftOverseasTransferAgreed] = useState(false);

  useEffect(() => {
    if (consentGate.open) {
      setPrivacyExpanded(true);
      setOverseasTransferExpanded(true);
      setDraftPrivacyAgreed(privacyAgreed);
      setDraftOverseasTransferAgreed(overseasTransferAgreed);
    }
  }, [consentGate.open, overseasTransferAgreed, privacyAgreed]);

  if (!consentGate.open) return null;

  const ready = draftPrivacyAgreed && draftOverseasTransferAgreed;

  return (
    <div
      role="presentation"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 200,
        padding: "16px 12px calc(16px + env(safe-area-inset-bottom, 0px))",
        background: "rgba(15,23,42,0.66)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="consent-gate-title"
        aria-describedby="consent-gate-description"
        style={{
          width: "min(100%, 456px)",
          maxHeight: "calc(100dvh - 32px)",
          overflowY: "auto",
          borderRadius: 22,
          padding: "20px 16px 16px",
          background: "var(--card-bg)",
          border: "1px solid var(--card-border)",
          boxShadow: "0 24px 70px rgba(15,23,42,0.4)",
          color: "var(--text)",
        }}
      >
        <h2 id="consent-gate-title" className="text-md" style={{ fontWeight: 900, color: "var(--accent)", marginBottom: 7 }}>
          개인정보 동의가 필요합니다
        </h2>
        <p id="consent-gate-description" className="text-sm" style={{ color: "var(--muted)", lineHeight: 1.6, marginBottom: 15 }}>
          {consentGate.actionLabel} 전에 정정된 수집·이용 고지와 AI 국외 이전 고지를 확인하고 각각 동의해주세요.
        </p>

        <PrivacyConsentFields
          dm={dm}
          privacyAgreed={draftPrivacyAgreed}
          setPrivacyAgreed={setDraftPrivacyAgreed}
          privacyExpanded={privacyExpanded}
          setPrivacyExpanded={setPrivacyExpanded}
          overseasTransferAgreed={draftOverseasTransferAgreed}
          setOverseasTransferAgreed={setDraftOverseasTransferAgreed}
          overseasTransferExpanded={overseasTransferExpanded}
          setOverseasTransferExpanded={setOverseasTransferExpanded}
        />

        {consentGate.error && (
          <p role="alert" className="text-sm" style={{ color: dm ? "#FF8F80" : "#C0392B", fontWeight: 800, marginBottom: 10, lineHeight: 1.5 }}>
            ⚠️ {consentGate.error}
          </p>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "minmax(0,0.8fr) minmax(0,1.2fr)", gap: 9 }}>
          <button
            type="button"
            onClick={closeConsentGate}
            disabled={consentGate.saving}
            className="btn3d text-sm"
            style={{ ...btn3d("outline", dm), minWidth: 0, minHeight: 48, borderRadius: 13, fontWeight: 800 }}
          >
            취소
          </button>
          <button
            type="button"
            onClick={() => confirmConsentGate({
              privacyAgreed: draftPrivacyAgreed,
              overseasTransferAgreed: draftOverseasTransferAgreed,
            })}
            disabled={!ready || consentGate.saving}
            className="btn3d text-sm"
            style={{
              ...btn3d("primary", dm),
              minWidth: 0,
              minHeight: 48,
              borderRadius: 13,
              fontWeight: 850,
              opacity: !ready || consentGate.saving ? 0.55 : 1,
            }}
          >
            {consentGate.saving ? "동의 저장 중..." : "동의하고 계속"}
          </button>
        </div>
      </section>
    </div>
  );
}
